import type { Route } from '@angular/router';
import { faBurn, faPlug } from '@fortawesome/pro-solid-svg-icons';
import { EnergySourceResolverService } from './energy-source-resolve.service';

export const contractsReviewRoutes: Route = {
  path: 'statistics',
  resolve: {
    energySource: EnergySourceResolverService,
  },
  children: [
    {
      path: 'power',
      children: [
        {
          path: 'contracts-review/:companyId/year/:year',
          loadComponent: () =>
            import('./contracts-review.component').then(
              (mod) => mod.ContractsReviewComponent,
            ),
          data: {
            translate: 'statistics.power',
            titleIcon: {
              icon: faPlug,
              class: 'power-icon',
            },
          },
        },
      ],
    },
    {
      path: 'gas',
      children: [
        {
          path: 'contracts-review/:companyId/year/:year',
          loadComponent: () =>
            import('./contracts-review.component').then(
              (mod) => mod.ContractsReviewComponent,
            ),
          data: {
            translate: 'statistics.gas',
            titleIcon: {
              icon: faBurn,
              class: 'gas-icon',
            },
          },
        },
      ],
    },
  ],
};
